export enum SoftPhoneCallEvent {
  Answered = 'phone.call.answered',
  Ended = 'phone.call.ended',
  Missed = 'phone.call.missed',
  Placed = 'phone.call.placed',
  Outbound = 'phone.prepare.outbound',
  /** Emitted for every webphone:call-failed event regardless of reason. */
  FailedGeneral = 'phone.call.failed-general',
}

// events are from https://github.com/servicetitan/telecom-webphone/blob/master/packages/application/src/utils/eventNames.ts
export const phoneCommandNames = {
  mute: 'mute',
  unmute: 'unmute',
  hold: 'hold',
  unhold: 'unhold',
  hangup: 'hangup',
  answer: 'answer',
  cancel: 'cancel',
  dial: 'dialer:dial',
  clear: 'dialer:clear',
  backspace: 'dialer:backspace',
  autoAction: 'dialer:autoAction',
  callNumber: 'dialer:callNumber',
  transfer: 'transfer',
  warmTransfer: 'transfer:warm',
  disconnect: 'disconnect',
  reportConnectionInfo: 'webphone:report-connection-info',
  collectDebugInfo: 'webphone:collect-debug-info',
  connect: 'connect',
  setAudioDevices: 'webphone:set-audio-devices',
  retryDeviceInitialization: 'webphone:retry-device-initialization',
  startMicMonitor: 'webphone:start-mic-monitor',
  stopMicMonitor: 'webphone:stop-mic-monitor',
  startNetworkTest: 'webphone:start-network-test',
};

export const webPhoneEventNames = {
  callState: 'webphone:call-state',
  dialerState: 'webphone:dialer-state',
  phoneState: 'webphone:phone-state',
  callEvent: 'webphone:call-event',
  registrationOverwritten: 'webphone:registration-overwritten',
  pcsTokenExpired: 'webphone:pcs-jwt-expired',
  debugInfo: 'webphone:debug-info',
  callFailed: 'webphone:call-failed',
  registrationInfo: 'webphone:registration-info',
  connectionStatusUpdate: 'webphone:connection-status-update',
  devicesReady: 'webphone:devices-ready',
  deviceListChanged: 'webphone:device-list-changed',
  audioDevicesChanged: 'webphone:audio-devices-changed',
  setAudioDevicesFailed: 'webphone:set-audio-devices-failed',
  deviceInitializationFailed: 'webphone:device-initialization-failed',
  micMonitorStarted: 'webphone:mic-monitor-started',
  micMonitorStopped: 'webphone:mic-monitor-stopped',
  micMonitorFailed: 'webphone:mic-monitor-failed',
  /** Emitted by webphone MFE while a network quality test is in progress. */
  networkTestProgress: 'webphone:network-test-progress',
  /** Emitted when the network test finishes; includes overall success and optional error. */
  networkTestResult: 'webphone:network-test-result',
};

/**
 * App-level EventEmitter2 events bridging the webphone bus to host modules
 * (e.g. UserStatusModule) without circular imports.
 */
export const webphoneAppEvents = {
  networkTestProgress: 'webphone.network-test.progress',
  networkTestResult: 'webphone.network-test.result',
} as const;

export const outgoingEventNames = {
  hostCommand: 'webphone:host-command',
  newPcsToken: 'webphone:pcs-jwt-newToken',
};

export const webPhoneLastTriggeringEventNames = {
  callStarted: 'call.created',
  callEnded: 'call.ringing.stopped',
  userAgentRegistered: 'userAgent.registration.registered',
  callHoldStarted: 'call.primary.hold',
  callHoldEnded: 'call.primary.unhold',
  callDemoted: 'call.demoted',
};
